import React from 'react';
import { Tag, TagProps } from 'antd';
import styles from './styles/EstimatedActualTag.module.css';

const EstimatedActualTag = ({
	estimated = true,
	slim = false,
	...rest
} : { estimated?: boolean; slim?: boolean } & TagProps) => {
	const label = slim ?
		(estimated ? 'E.' : 'A.') :
		(estimated ? 'Est.' : 'Act.');

	return (
		<Tag
			className={slim ? styles.slimTag : styles.tag}
			color={estimated ? 'gold' : 'gray'}
			{...rest}
		>
			{label}
		</Tag>
	);
};

export default EstimatedActualTag;
